import PropTypes from 'prop-types';
// import AdminNavbar from 'components/Navbar';
import './mainlayout.scss';
import { Sidebar } from 'components/common/Sidebar';
import { useCallback, useEffect, useState } from 'react';
import useWindowSize from 'hooks/useWindowSize';
import { MobileSidebar } from 'components/common/MobileSidebar';
import { history } from 'helpers';
import { menuItems } from 'Data/staticDatas';
import routers from 'routes/routes';
import { getAccessToken, getCookie } from 'helpers/utis';
import { logout } from 'service/utilities';

export function MainLayout(props) {
  const { children } = props;
  // check window width
  const width = useWindowSize();
  // toggle sidebar and menu with state
  const [isOpen, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  // toggle menu and sidebar function
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const toggle = () => setOpen(!isOpen);

  const websiteGuard = useCallback(() => {
    // if (!getCookie('token')) logout();
  }, []);

  useEffect(() => {
    websiteGuard();
  });
  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
  }, []);

  useEffect(() => {
    const token = getAccessToken();
    if (!token) {
      logout();
    }
  }, []);

  useEffect(() => {
    menuItems.forEach((val) => {
      if (history.location.pathname.includes(val?.link)) {
        handleClose();
      }
    });
  }, [history.location.pathname]);

  useEffect(() => {
    const currentUrl = window.location.pathname;
    const isUrlValid = routers.some((route) => {
      if (route.childrens) {
        return route.childrens.some((childRoute) => {
          const fullPath = route.path + childRoute.path;
          return fullPath === currentUrl;
        });
      }
      return false;
    });
    if (!isUrlValid) {
      // history.push('/404');
    }
  }, []);

  useEffect(() => {
    const tabsOpen = localStorage.getItem('tabsOpen');
    const rememberMe = getCookie('rememberMe');
    if (tabsOpen === null) {
      localStorage.setItem('tabsOpen', 1);
    } else {
      localStorage.setItem('tabsOpen', Number(tabsOpen) + 1);
    }

    const decrementCounter = () => {
      const newTabCount = localStorage.getItem('tabsOpen');
      if (newTabCount !== null) {
        const updatedCount = Number(newTabCount) - 1;
        localStorage.setItem('tabsOpen', updatedCount);
        if (updatedCount === 0) {
          if (rememberMe !== 'true') localStorage.clear();
        }
      }
    };

    window.addEventListener('beforeunload', decrementCounter);

    return () => {
      window.removeEventListener('beforeunload', decrementCounter);
    };
  }, []);

  return (
    <>
      {width > 768 ? (
        <div className={`main-layout `}>
          <Sidebar toggle={toggle} isOpen={isOpen} />
          <div className="main-layout-wrapper">
            {/* <AdminNavbar isOpen={isOpen} /> */}
            <div
              className={`px-5 main-content-wrapper ${
                isOpen ? 'open-layout' : 'closed-layout'
              }`}
            >
              {children}
            </div>
          </div>
        </div>
      ) : (
        <>
          <MobileSidebar
            show={show}
            handleClose={handleClose}
            handleShow={handleShow}
            mobileChildren={children}
          />
        </>
      )}
    </>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired
};
